import React, { useState, useEffect } from 'react';
import { Pill } from 'module-tsl-ui-elements';
import { getFromContext } from '../../AlertFiltersContext';

export const SelectedFilters = () => {
  const { state, dispatch } = getFromContext();
  const { editing, facets, prefix } = state;

  const [selectedFacets, setSelectedFacets] = useState(facets);

  useEffect(() => {
    setSelectedFacets(facets);
  }, [facets]);

  return (
    <div className={`${prefix}__content__selected`}>
      <div className={`${prefix}__content__selected__heading`}>My alert filters</div>
      {selectedFacets.length === 0 ? (
        <span>Your filters will appear here when selected</span>
      ) : (
        <ul>
          {selectedFacets.map((facet) => (
            <Pill
              key={facet.queryStringId}
              tag={!editing}
              theme="white"
              closeRight
              onClose={() => dispatch({ type: 'remove', facet })}
            >
              {facet.name}
            </Pill>
          ))}
        </ul>
      )}
    </div>
  );
};
